import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("style", { children: "\n    .spinner-dots {\n  transform-origin: center;\n  animation: dot-animation 1s step-end infinite;\n    }\n    @keyframes dot-animation {\n      8.3% {\n        transform: rotate(30deg);\n      }\n      16.6% {\n        transform: rotate(60deg);\n      }\n      25% {\n        transform: rotate(90deg);\n      }\n      33.3% {\n        transform: rotate(120deg);\n      }\n      41.6% {\n        transform: rotate(150deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      58.3% {\n        transform: rotate(210deg);\n      }\n      66.6% {\n        transform: rotate(240deg);\n      }\n      75% {\n        transform: rotate(270deg);\n      }\n      83.3% {\n        transform: rotate(300deg);\n      }\n      91.6% {\n        transform: rotate(330deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n  " }), /* @__PURE__ */ _jsxs("g", {
		className: "spinner-dots",
		stroke: "currentColor",
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 2.5,
				r: 1.5,
				opacity: .14
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16.75,
				cy: 3.77,
				r: 1.5,
				opacity: .29
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 20.23,
				cy: 7.25,
				r: 1.5,
				opacity: .43
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 21.5,
				cy: 12,
				r: 1.5,
				opacity: .57
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 20.23,
				cy: 16.75,
				r: 1.5,
				opacity: .71
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16.75,
				cy: 20.23,
				r: 1.5,
				opacity: .86
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 21.5,
				r: 1.5
			})
		]
	})]
});
export default SvgSpinnerDots;
